"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEXT_DUE_PAST_COPY = exports.NEXT_DUE_REQUIRED_COPY = void 0;
exports.defaultNextDue = defaultNextDue;
exports.nextDueRequired = nextDueRequired;
exports.nextDueLabel = nextDueLabel;
const pad = (n) => (n < 10 ? `0${n}` : String(n));
const iso = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;
const lastDay = (y, m) => new Date(Date.UTC(y, m, 0)).getUTCDate();
function parts(date) {
    const [y, m, d] = date.split("-").map(Number);
    return [y, m, d];
}
function addDays(date, days) {
    const [y, m, d] = parts(date);
    const t = new Date(Date.UTC(y, m - 1, d + days));
    return iso(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
/** `add_months`: the same day of the month, clamped to the target month's end. */
function addMonths(date, months) {
    const [y, m, d] = parts(date);
    const total = m - 1 + months;
    const year = y + Math.floor(total / 12);
    const month = (((total % 12) + 12) % 12) + 1;
    return iso(year, month, Math.min(d, lastDay(year, month)));
}
/** `semimonthly_at(today, 0, days)`: the first scheduled date on or after today. */
function semimonthlyNext(today, days) {
    const [y, m, d] = parts(today);
    const first = days[0];
    const second = Math.min(days[1], lastDay(y, m));
    if (d <= first)
        return iso(y, m, first);
    if (d <= second)
        return iso(y, m, second);
    const ny = m === 12 ? y + 1 : y;
    const nm = m === 12 ? 1 : m + 1;
    return iso(ny, nm, first);
}
function defaultNextDue(frequency, today, semimonthlyDays) {
    if (frequency === "semimonthly" && semimonthlyDays?.length === 2) {
        return semimonthlyNext(today, semimonthlyDays);
    }
    const months = { monthly: 1, quarterly: 3, yearly: 12 }[frequency];
    if (months)
        return addMonths(today, months);
    const days = { weekly: 7, biweekly: 14, semimonthly: 15 }[frequency];
    return addDays(today, days ?? 30);
}
/** Quarterly and yearly rows are too far apart for a guess: the user says when. */
function nextDueRequired(frequency) {
    return frequency === "quarterly" || frequency === "yearly";
}
function nextDueLabel(isIncome) {
    return isIncome ? "Next payday" : "Next due";
}
exports.NEXT_DUE_REQUIRED_COPY = "Enter the date the next one is due, so your forecast puts it in the right month.";
exports.NEXT_DUE_PAST_COPY = "Pick today or a later date.";
//# sourceMappingURL=nextDue.js.map